// Modules
import React, { useEffect, useState } from "react";
import { HashLink as Link } from "react-router-hash-link";
import { useLocation } from "react-router-dom";

// Local
import ProgressBar from "../utils/ProgressBar";
import LogoLink from "../utils/LogoLink";

// Assets
import "./navbar-mobile.scss";

const NavbarMobile = () => {
  const location = useLocation();
  const [urlWithParams, setUrlWithParams] = useState(null);
  const [activeLink, setActiveLink] = useState("carousel");
  const [isFound, setIsFound] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  /**
   * Listener on URL that changes the clicked section in the URL parameters
   */
  useEffect(() => {
    const section = location.hash.split("#")[1];
    const pathname = location.pathname.split("/")[1];
    const search = location.search.split("/")[0];
    const currUrlWithParams = `${pathname}${search}`;

    setUrlWithParams(currUrlWithParams);

    if (location.pathname.includes("/page-not-found") === true)
      setIsFound(false);
    if (
      section === "carousel"
      || section === "details-of-rent"
      || section === "co-property"
      || section === "home-improvments"
      || section === "neighborhood"
      || section === "balance-sheet"
    )
      setActiveLink(section);
    else
      setActiveLink("carousel");
  }, [location]);

  /**
   * Sets the correct underline section on scroll.
   * Triggered on scroll.
   * @param {Event} evt 
   */
  const onScrollEvent = (evt) => {
    const scrolled = document.documentElement.scrollTop;
    const scrollLength = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const progress = (100 * scrolled) / scrollLength;

    if (progress < 8.5)
      setActiveLink("carousel");
    else if (progress >= 8.5 && progress < 21)
      setActiveLink("details-of-rent");
    else if (progress >= 21 && progress < 35.5)
      setActiveLink("co-property");
    else if (progress >= 35.5 && progress < 45)
      setActiveLink("home-improvments");
    else if (progress >= 45 && progress < 59)
      setActiveLink("neighborhood");
    else if (progress >= 59)
      setActiveLink("balance-sheet");
  };

  /**
   * Handles the presence of the scrolling listener.
   * Equivalent of componentDidMount()
   */
  useEffect(() => {
    document.addEventListener("wheel", onScrollEvent);

    /* Equivalent of componentWillUnmount() */
    return () => document.removeEventListener("wheel", onScrollEvent);
  }, []);

  /**
   * Adds an offset on the scrolling to the requested section in order to be perfectly aligned.
   * Triggered onClick of links in the navbar.
   * @param {HTMLElement} el : DOM element
   */
  const scrollWithOffset = (el) => {
    const vh = parseFloat(document.documentElement.style.getPropertyValue("--vh").replace("px", ""));
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -18 * vh;

    window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
  };

  const handleOpenMenu = () => {
    setIsOpen(false);
  }

  return (
    <header className={`navbar-container-mobile ${isOpen ? "open" : "close"}`}>
      <div className="header-menu-container">
        <LogoLink clssName="logo" type="primary" />
        {isFound === true
          ? (
            <div
              onClick={() => setIsOpen(!isOpen)}
              className={`burger-icon-menu-container ${isOpen ? "open" : "close"}`}
            >
              <span className="span-burger-icon span-1" />
              <span className="span-burger-icon span-2" />
              <span className="span-burger-icon span-3" />
              <span className="span-burger-icon span-4" />
            </div>
          ) : null}
      </div>
      {isFound === true
        ? (
          <div className="links-container">
            <Link
              onClick={() => handleOpenMenu()}
              to={`/${urlWithParams}/#carousel`}
              scroll={(el) => scrollWithOffset(el)}
              title="Carrousel"
              className={`link ${activeLink === "carousel" ? "active" : ""}`}
            >
              Informations clés
            </Link>
            <Link
              onClick={() => handleOpenMenu()}
              to={`/${urlWithParams}/#details-of-rent`}
              scroll={(el) => scrollWithOffset(el)}
              title="Détails et plan du bien"
              className={`link ${activeLink === "details-of-rent" ? "active" : ""
                }`}
            >
              Détails du bien
            </Link>
            <Link
              onClick={() => handleOpenMenu()}
              to={`/${urlWithParams}/#co-property`}
              scroll={(el) => scrollWithOffset(el)}
              title="Copropriété"
              className={`link ${activeLink === "co-property" ? "active" : ""}`}
            >
              Copropriété
            </Link>
            <Link
              onClick={() => handleOpenMenu()}
              to={`/${urlWithParams}/#home-improvments`}
              scroll={(el) => scrollWithOffset(el)}
              title="Aménagements et travaux"
              className={`link ${activeLink === "home-improvments" ? "active" : ""
                }`}
            >
              Aménagements
            </Link>
            <Link
              onClick={() => handleOpenMenu()}
              to={`/${urlWithParams}/#neighborhood`}
              scroll={(el) => scrollWithOffset(el)}
              title="Le quartier et ses environs"
              className={`link ${activeLink === "neighborhood" ? "active" : ""}`}
            >
              Le quartier
            </Link>
            <Link
              onClick={() => handleOpenMenu()}
              to={`/${urlWithParams}/#balance-sheet`}
              scroll={(el) => scrollWithOffset(el)}
              title="Bilan et simulateur"
              className={`link ${activeLink === "balance-sheet" ? "active" : ""}`}
            >
              Bilan financier
            </Link>
          </div>
        ) : null}
      <ProgressBar clssName="progress-bar" />
    </header>
  );
};

export default NavbarMobile;
